import React, { useState } from 'react';

import { useSearchBox } from 'react-instantsearch-core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';
import config from 'react-global-configuration';
import className from 'classnames';

import { useMenu, useClearRefinements } from 'react-instantsearch';

import {
  facetAttributes,
} from '../config';

import ApiAutocomplete from '../../ApiAutocomplete';
import { APP_OPTIONS, SEARCH_PATH } from '../../../config/constants';

import './style.scss';

const MUNICIPALITY_TYPE = 'gemeente';

const SearchBar = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const API_URL = config.get('API_URL');
  const [searchItem, setSearchItem] = useState();

  const {
    refine,
  } = useSearchBox(props);

  const requestTypeFacet = facetAttributes.filter((facetAttribute) => facetAttribute.field === 'field_request_type')[0];
  const {
    refine: refineFacet,
  } = useMenu(requestTypeFacet);

  const { refine: clearActiveFacets } = useClearRefinements(requestTypeFacet);
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const initialInputQuery = useSelector((state) => state.getIn(['router', 'location', 'query', encodeURIComponent(`${APP_OPTIONS.parameters.searchkitIndexAlLProjects}[input]`)], ''));

  // Go to the search page with the query and request type values.
  const handleSubmit = (e, b) => {
    e.preventDefault();

    const inputValue = e.target[0].value;
    const requestTypeQueryValue = e.nativeEvent.submitter.dataset.target;

    if (path === SEARCH_PATH) {
      refine(searchItem?.gemeente || inputValue);
      clearActiveFacets();
      refineFacet(requestTypeQueryValue);
    } else {
      const query = encodeURIComponent(`${APP_OPTIONS.parameters.searchkitIndexAlLProjects}[query]`);
      const input = encodeURIComponent(`${APP_OPTIONS.parameters.searchkitIndexAlLProjects}[input]`);
      const requestTypeQuery = encodeURIComponent(`${APP_OPTIONS.parameters.searchkitIndexAlLProjects}[menu][field_request_type]`);

      const newPath = `${SEARCH_PATH}?${query}=${searchItem?.gemeente || inputValue}&${requestTypeQuery}=${requestTypeQueryValue}&${input}=${searchItem?.name || inputValue}`;

      history.push(newPath);
    }
  };

  return (
    <div className="SearchBar" id="SearchBar">
      <form onSubmit={handleSubmit}>
        <ApiAutocomplete
          name="search_input"
          id="search_input"
          endpoint={`${API_URL}/api/autocomplete`}
          placeholder={t('maatjes_search.input_placeholder')}
          onSelectItem={(item) => {
            setSearchItem(item);
          }}
          onChange={() => {
            setSearchItem(null);
          }}
          defaultValue={decodeURIComponent(initialInputQuery)}
          renderItem={(item, active) => {
            const classes = className({
              active: active,
            });
            return (
              <div className={classes}>
                {item.name}
                {item.type === MUNICIPALITY_TYPE
                  && <> {t('projectmap_township')}</>}
              </div>
            );
          }}
        />
        <div className="SearchBar__actions">
          <Button type="submit" data-target="maatje_worden" className="Button icon-arrow-right icon-before icon-after moving-arrow">
            {t('maatjes.search.button_become_maatje')}
          </Button>
          <Button type="submit" data-target="maatje_zoeken" className="Button icon-arrow-right icon-before icon-after moving-arrow">
            {t('maatjes.search.button_search_maatje')}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;
